import Layout from "../../../components/Layout";
import FormPostFunc from "../Formularios/formPostFunc";

export default function PostFunc() {
  return Layout(FormPostFunc, "Funcionarios");
}
